<template>
  <div class="flex flex-col gap-6">
    <h1 class="font-bold text-3xl">Indicador de tendência</h1>
    <div class="flex items-center justify-center gap-6">
      <div class="w-full">
        <img src="/img/trend-modal.svg" alt="Gráfico sparkline explicativo da tendência" class="w-full" />
      </div>
      <div class="flex flex-col text-xs gap-2 w-full">
        <div class="flex items-center gap-4">
          <svg width="32" height="10">
            <line
              x1="2"
              x2="30"
              y1="5"
              y2="5"
              style="fill: none; stroke: #17c177; stroke-width: 2; stroke-linecap: round"
            ></line>
          </svg>
          <p>Preço atual <strong class="text-ontick-green-600 font-bold">acima</strong> do preço de abertura</p>
        </div>
        <div class="flex items-center gap-4">
          <svg width="32" height="10">
            <line
              x1="2"
              x2="30"
              y1="5"
              y2="5"
              style="fill: none; stroke: #e47529; stroke-width: 2; stroke-linecap: round"
            ></line>
          </svg>
          <p>Preço atual <strong class="text-ontick-orange-600 font-bold">abaixo</strong> do preço de abertura</p>
        </div>
        <div class="flex items-center gap-4">
          <svg width="32" height="10">
            <line
              x1="2"
              x2="30"
              y1="5"
              y2="5"
              style="fill: none; stroke: #e47529; stroke-width: 2; stroke-linecap: round; stroke-dasharray: 4"
            ></line>
          </svg>
          <p>Projeção de preço <strong class="text-gray-500">entre</strong> o fechamento e a abertura</p>
        </div>
        <div class="flex items-center gap-4">
          <svg width="32" height="10">
            <line
              x1="2"
              x2="30"
              y1="5"
              y2="5"
              style="fill: none; stroke: #737373; stroke-width: 2; stroke-linecap: round; stroke-dasharray: 4"
            ></line>
          </svg>
          <p>Preço de <strong>abertura</strong> do dia atual</p>
        </div>
      </div>
    </div>
    <p class="text-sm">
      O <strong>sparkline</strong> representa a variação do preço do ativo nos últimos 180 minutos. A linha média indica
      o preço do ativo no início do dia (abertura do pregão). A linha pontilhada conecta o espaço entre o
      <strong>preço de fechamento</strong> do dia anterior e o <strong>preço de abertura</strong> do dia atual.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.line {
  width: 44px;
}
</style>
